export default __webpack_public_path__ + "static/media/film.e925c554.webm";